import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getRedirectTarget, commonProblematicRedirects } from '@/data/redirectMapping';

const UrlRedirectHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check for exact matches in our redirect mapping first
    const redirectTarget = getRedirectTarget(location.pathname);
    
    if (redirectTarget) {
      // Use replace instead of navigate to create a 301-like redirect
      navigate(redirectTarget, { replace: true });
      return;
    }

    // Check common problematic redirects
    const commonRedirect = commonProblematicRedirects[location.pathname];
    if (commonRedirect) {
      navigate(commonRedirect, { replace: true });
      return;
    }

    // Fallback: decode any remaining double-encoded URLs manually
    if (location.pathname.includes('%25')) {
      try {
        const decodedOnce = decodeURIComponent(location.pathname);
        const decodedTwice = decodeURIComponent(decodedOnce);
        
        if (decodedTwice !== location.pathname) {
          // Re-encode properly
          const segments = decodedTwice.split('/').filter(Boolean);
          const properlyEncoded = '/' + segments.map(segment => encodeURIComponent(segment)).join('/');
          navigate(properlyEncoded, { replace: true });
        }
      } catch (error) {
        console.warn('Failed to decode URL:', location.pathname, error);
      }
    }
  }, [location.pathname, navigate]);

  return <>{children}</>;
};

export default UrlRedirectHandler;